import { UserRole } from "../types/entities";

export const roleColors: Record<UserRole, string> = {
  administrator: "#6772e6",
  executive: "#55acee",
  program_manager: "#cb7531",
  master: "#6772e6",
  staff: "#b05bdb",
  client: "#b05bdb",
  team_viewer: "#6bbd7d",
  client_viewer: "#6bbd7d"
};

export const seatRoles: UserRole[] = [
  "master",
  "executive",
  "program_manager",
  "administrator",
  "staff",
  "client"
];

export const userRoles: Record<UserRole, string> = {
  master: "Account Owner",
  executive: "Executive",
  program_manager: "Program Manager",
  administrator: "Administrator",
  staff: "Team User",
  client: "Client User",
  team_viewer: "Team Viewer",
  client_viewer: "Client Viewer"
};
